<mat-radio-group class="gwc-radio"
  color="primary"
  [class.gwc-radio--error]="formControl.touched && !formControl.valid"
  [formControl]="formControl">
  @for (option of radioOptions; track option.value) {
    <mat-radio-button class="gwc-radio__option"
      [value]="option.value">
      <span class="gwc-radio__label">{{ option.label }}</span>
      @if (option.description) {
        <p class="gwc-radio__description">{{ option.description }}</p>
      }
    </mat-radio-button>
  }
</mat-radio-group>
